module.exports = __webpack_public_path__ + "media/images/ask-cindy-c25ff40244a2bbde7539d7c71151ea75.png";